<template>
    <div class="cms-container px-2" :class="{ 'dimmed': showFilterModal || showEditArticleModal || showDeleteModal }">
        <ToastCMS ref="toast" />

        <!-- FILTER MODAL -->
        <div v-if="showFilterModal"
            class="modal-overlay d-flex align-items-center justify-content-center fixed-top w-100 h-100 left-0"
            @mousedown="onOverlayMouseDown" @mouseup="onOverlayMouseUp">
            <div class="modal-content bg-white overflow-hidden">
                <div class="modal-header d-flex justify-content-between align-items-center px-3 py-3">
                    <h2 class="m-0 text-dark">Filter</h2>
                    <button class="text-dark bg-transparent border-0 material-symbols-outlined"
                        @click="closeModals">close</button>
                </div>
                <form class="modal-body mt-1" @submit.prevent="applyFilters">
                    <div class="w-100">
                        <div class="d-flex align-items-center justify-content-between mb-1">
                            <label for="newscategory" class="text-dark mb-0">Category:</label>
                            <button type="button" @click="tempCategory = ''; tempFromDate = ''; tempToDate = ''"
                                class="vmc-bg-prime-4 rounded px-3 py-1 text-white border-0"
                                style="font-size:0.8rem;">Reset All</button>
                        </div>
                        <select v-model="tempCategory" class="w-100 text-dark" id="newscategory"
                            style="outline:none; height:30px;">
                            <option value="" class="text-dark">All</option>
                            <option value="Company News" class="text-dark">Company News</option>
                            <option value="Crew Updates" class="text-dark">Crew Updates</option>
                            <option value="Government Advisories" class="text-dark">Government Advisories</option>
                        </select>
                    </div>
                    <div class="d-flex align-items-center justify-content-center" style="gap:5px;">
                        <div class="w-100 mt-4">
                            <label for="fromdate" class="text-dark">From:</label>
                            <input type="date" v-model="tempFromDate" id="fromdate" class="w-100 text-dark px-1"
                                style="outline:none; height:30px;">
                        </div>
                        <div class="w-100 mt-4">
                            <label for="todate" class="text-dark">To:</label>
                            <input type="date" v-model="tempToDate" id="todate" class="w-100 text-dark px-1"
                                style="outline:none; height:30px;">
                        </div>
                    </div>
                    <div class="d-flex justify-content-end mt-3" style="gap:10px;">
                        <button type="submit" class="vmc-bg-prime-5 rounded px-3 py-1 text-white border-0">Search
                            Filter</button>
                        <button type="button" class="vmc-bg-prime-4 rounded px-3 py-1 text-white border-0"
                            @click="closeModals">Cancel</button>
                    </div>
                </form>
            </div>
        </div>

        <!-- EDIT MODAL -->
        <div v-if="showEditArticleModal"
            class="modal-overlay d-flex align-items-center justify-content-center fixed-top w-100 h-100 left-0"
            @mousedown="onOverlayMouseDown" @mouseup="onOverlayMouseUp">
            <div class="modal-content bg-white overflow-hidden">
                <div class="modal-header d-flex justify-content-between align-items-center px-3 py-3">
                    <h2 class="m-0 text-dark">Edit Article</h2>
                    <button class="text-dark bg-transparent border-0 material-symbols-outlined"
                        @click="closeModals">close</button>
                </div>
                <form class="modal-body mt-1" @submit.prevent="saveEdit">
                    <div class="w-100">
                        <label class="text-dark">Article Title</label>
                        <input type="text" v-model="editForm.title" class="w-100 text-dark px-1"
                            style="outline:none; height:30px;">
                    </div>
                    <div class="w-100 mt-3">
                        <label class="text-dark">Category:</label>
                        <select v-model="editForm.category" class="w-100 text-dark" style="outline:none; height:30px;">
                            <option value="" disabled>---Choose Category---</option>
                            <option value="Company News">Company News</option>
                            <option value="Crew Updates">Crew Updates</option>
                            <option value="Government Advisories">Government Advisories</option>
                        </select>
                    </div>
                    <div class="w-100 mt-3">
                        <label class="text-dark">Author</label>
                        <input type="text" v-model="editForm.author" class="w-100 text-dark px-1"
                            style="outline:none; height:30px;">
                    </div>
                    <div class="w-100 mt-3">
                        <label class="text-dark">Description</label>
                        <textarea rows="3" v-model="editForm.content" class="w-100 text-dark px-1"
                            style="resize:none;"></textarea>
                    </div>
                    <div class="d-flex justify-content-end mt-3" style="gap:10px;">
                        <button type="submit" class="vmc-bg-prime-5 rounded px-3 py-1 text-white border-0">Save
                            Changes</button>
                        <button type="button" class="vmc-bg-prime-4 rounded px-3 py-1 text-white border-0"
                            @click="closeModals">Cancel</button>
                    </div>
                </form>
            </div>
        </div>

        <!-- DELETE CONFIRM MODAL -->
        <div v-if="showDeleteModal"
            class="modal-overlay d-flex align-items-center justify-content-center fixed-top w-100 h-100 left-0"
            @mousedown="onOverlayMouseDown" @mouseup="onOverlayMouseUp">
            <div class="modal-content bg-white overflow-hidden">
                <div class="modal-header d-flex justify-content-between align-items-center px-3 py-3">
                    <h2 class="m-0 text-dark">Delete Article</h2>
                    <button class="text-dark bg-transparent border-0 material-symbols-outlined"
                        @click="closeModals">close</button>
                </div>
                <div class="modal-body mt-1">
                    <p class="text-dark mb-0">Are you sure you want to delete this article?</p>
                    <div class="d-flex justify-content-end mt-3" style="gap:10px;">
                        <button type="button" @click="confirmDelete"
                            class="vmc-bg-prime-5 rounded px-3 py-1 text-white border-0">Yes</button>
                        <button type="button" @click="closeModals"
                            class="vmc-bg-prime-4 rounded px-3 py-1 text-white border-0">No</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- SEARCH + FILTER BAR -->
        <div class="search-container d-md-flex align-items-md-center justify-content-md-end px-2" style="gap:10px;">
            <div class="filter">
                <button type="button" @click="showFilterModal = true"
                    class="d-flex align-items-center vmc-bg-prime-4 text-white border-0 rounded py-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="none"
                        stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path
                            d="M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z" />
                    </svg>
                </button>
            </div>
            <input type="text" v-model="searchQuery" @input="resetPage" placeholder="Search..."
                class="search-bar text-dark p-1" style="outline:none;" />
        </div>

        <!-- TABLE -->
        <div class="table-container overflow-auto mt-2">
            <table class="w-100 min-w-100">
                <thead>
                    <tr>
                        <th class="p-2">Author</th>
                        <th class="p-2">Article Title</th>
                        <th class="p-2">Category</th>
                        <th class="p-2">Description</th>
                        <th class="p-2">Date</th>
                        <th class="p-2">Edit/Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="article in paginatedUsers" :key="article.id" class="border-bottom">
                        <td class="p-2 text-dark">{{ article.author || 'No data found.' }}</td>
                        <td class="p-2 text-dark">{{ article.title || 'No data found.' }}</td>
                        <td class="p-2 text-dark">{{ article.category || 'No data found.' }}</td>
                        <td class="p-2 text-dark description-clamp">{{ article.content || 'No data found.' }}</td>
                        <td class="p-2 text-dark">
                            {{ article.date ? formatDate(article.date.split(' | ')[0]) : 'No data found.' }}<br>
                            {{ article.date ? article.date.split(' | ')[1] : '' }}
                        </td>
                        <td class="p-2">
                            <div class="d-flex align-items-center" style="gap:5px;">
                                <button type="button" @click="openEditModal(article)"
                                    class="vmc-bg-prime-4 py-1 rounded border-0 d-flex align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24"
                                        fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <path
                                            d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" />
                                        <path d="m15 5 4 4" />
                                    </svg>
                                </button>
                                <button type="button" @click="openDeleteModal(article)"
                                    class="vmc-bg-prime-5 py-1 rounded border-0 d-flex align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24"
                                        fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <path d="M10 11v6" />
                                        <path d="M14 11v6" />
                                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
                                        <path d="M3 6h18" />
                                        <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                                    </svg>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="paginatedUsers.length === 0" class="border-bottom">
                        <td colspan="6" class="text-dark text-center p-2">No data found.</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <hr class="px-0">
        <div class="table-footer" style="padding:0 10px;">
            <div class="d-flex align-items-center justify-content-center">
                <p v-if="filteredUsers.length === 0" style="font-weight:400; color: #212529;">
                    Showing 0 to 0 of 0 entries
                </p>
                <p v-else-if="filteredUsers.length === 1" style="font-weight:400; color: #212529;">
                    Showing 1 to 1 of 1 entry
                </p>
                <p v-else style="font-weight:400; color: #212529;">
                    Showing {{ entryStart }} to {{ entryEnd }} of {{ filteredUsers.length }} entries
                </p>
            </div>
            <div class="d-flex align-items-center justify-content-center">
                <p class="next-previous" @click="firstPage" :disabled="currentPage === 1"
                    style="border:none; cursor:pointer;">&#60;&#60;</p>
                <p class="next-previous" @click="prevPage" :disabled="currentPage === 1"
                    style="border:none; padding:0 10px; cursor:pointer;">&#60;</p>
                <p v-if="paginatedUsers.length === 0" class="mx-2">{{ totalPages }} of {{ totalPages }}</p>
                <p v-else class="mx-2">{{ currentPage }} of {{ totalPages }}</p>
                <p class="next-previous" @click="nextPage" :disabled="currentPage === totalPages"
                    style="border:none; padding:0 10px; cursor:pointer;">&#62;</p>
                <p class="next-previous" @click="lastPage" :disabled="currentPage === totalPages"
                    style="border:none; cursor:pointer;">&#62;&#62;</p>
            </div>
        </div>
    </div>
</template>

<script>
import ToastCMS from '../ToastCMS.vue';
export default {
    name: "NewsHistoryCMS",
    components: { ToastCMS },
    data() {
        return {
            articles: [],
            currentPage: 1,
            perPage: 10,
            searchQuery: '',
            showFilterModal: false,
            showEditArticleModal: false,
            showDeleteModal: false,
            tempCategory: '',
            tempFromDate: '',
            tempToDate: '',
            selectedFromDate: '',
            selectedToDate: '',
            selectedCategory: '',
            editIndex: null,
            editForm: {
                id: null,
                title: '',
                category: '',
                author: '',
                content: '',
            },
            deleteTarget: null,
            overlayMouseDownOnOverlay: false,
        }
    },

    async mounted() {
        window.addEventListener('keydown', this.onKeyboard);
        await this.loadArticles();
    },

    beforeDestroy() {
        window.removeEventListener('keydown', this.onKeyboard);
    },

    computed: {
        filteredUsers() {
            let result = this.articles;
            if (this.searchQuery) {
                const query = this.searchQuery.toLowerCase();
                result = result.filter(a =>
                    (a.author || '').toLowerCase().includes(query) ||
                    (a.title || '').toLowerCase().includes(query) ||
                    (a.category || '').toLowerCase().includes(query) ||
                    (a.content || '').toLowerCase().includes(query) ||
                    (a.date || '').includes(query)
                );
            }
            if (this.selectedCategory) {
                result = result.filter(a => a.category === this.selectedCategory);
            }

            if (this.selectedFromDate || this.selectedToDate) {
                result = result.filter(a => {
                    if (!a.date) return false;

                    const articleDate = new Date(a.date.split(' | ')[0]);

                    if (this.selectedFromDate) {
                        const from = new Date(this.selectedFromDate);
                        if (articleDate < from) return false;
                    }

                    if (this.selectedToDate) {
                        const to = new Date(this.selectedToDate);
                        if (articleDate > to) return false;
                    }

                    return true;
                });
            }

            return result;
        },

        paginatedUsers() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredUsers.slice(start, end);
        },

        totalPages() {
            return Math.ceil(this.filteredUsers.length / this.perPage);
        },

        entryStart() {
            if (this.filteredUsers.length === 0) return 0;
            return (this.currentPage - 1) * this.perPage + 1;
        },

        entryEnd() {
            return Math.min(this.currentPage * this.perPage, this.filteredUsers.length);
        },
    },

    methods: {
        async loadArticles() {
            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/content`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) throw new Error("Failed to fetch");
                const data = await response.json();
                this.articles = Array.isArray(data.newsArticles)
                    ? data.newsArticles.filter(a => a.title && a.author && a.category && a.content)
                    : [];
            } catch (error) {
                console.error("Load error:", error);
                this.$refs.toast.showToast("Failed to load articles.", "error");
            }
        },

        async saveToBackend() {
            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/update`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) throw new Error("Failed to fetch");
                const data = await response.json();
                const payload = { ...data, newsArticles: this.articles };
                const saveResponse = await fetch(`${process.env.VUE_APP_API_URL}/api/update`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                        'Cache-Control': 'no-cache'
                    },
                    body: JSON.stringify(payload)
                });
                if (!saveResponse.ok) throw new Error("Save failed");
                return true;
            } catch (error) {
                console.error("Save error:", error);
                this.$refs.toast.showToast("Failed to save changes.", "error");
                return false;
            }
        },

        openEditModal(article) {
            this.editIndex = this.articles.findIndex(a => a.id === article.id);
            this.editForm = { ...article };
            this.showEditArticleModal = true;
        },

        async saveEdit() {
            if (this.editIndex === null) return;
            const original = this.articles[this.editIndex];
            const now = new Date();
            const date = now.toISOString().slice(0, 10);
            const time = now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true });
            this.articles.splice(this.editIndex, 1, {
                ...original,
                title: this.editForm.title,
                category: this.editForm.category,
                author: this.editForm.author,
                content: this.editForm.content,
                date: `${date} | ${time}`,
            });
            const success = await this.saveToBackend();
            if (success) {
                this.$refs.toast.showToast("Article updated.", "success");
                this.closeModals();
            }
        },

        openDeleteModal(article) {
            this.deleteTarget = article;
            this.showDeleteModal = true;
        },

        async confirmDelete() {
            if (!this.deleteTarget) return;
            const index = this.articles.findIndex(a => a.id === this.deleteTarget.id);
            if (index === -1) return;
            this.articles.splice(index, 1);
            const success = await this.saveToBackend();
            if (success) {
                this.$refs.toast.showToast("Article deleted.", "error");
                this.resetPage();
            }
            this.deleteTarget = null;
            this.closeModals();
        },

        closeModals() {
            this.showFilterModal = false;
            this.showEditArticleModal = false;
            this.showDeleteModal = false;
            this.editIndex = null;
        },

        applyFilters() {
            this.selectedCategory = this.tempCategory;
            this.selectedFromDate = this.tempFromDate;
            this.selectedToDate = this.tempToDate;
            this.currentPage = 1;
            this.closeModals();
        },

        formatDate(dateStr) {
            if (!dateStr) return '';
            const [year, month, day] = dateStr.split('-');
            return `${month}/${day}/${year}`;
        },

        nextPage() { if (this.currentPage < this.totalPages) this.currentPage++; },
        prevPage() { if (this.currentPage > 1) this.currentPage--; },
        lastPage() { this.currentPage = this.totalPages; },
        firstPage() { this.currentPage = 1; },
        resetPage() { this.currentPage = 1; },

        onKeyboard(e) {
            if (this.showFilterModal || this.showEditArticleModal || this.showDeleteModal) {
                if (e.key === 'Escape') this.closeModals();
            }
        },

        onOverlayMouseDown(e) {
            this.overlayMouseDownOnOverlay = e.target.classList.contains('modal-overlay');
        },

        onOverlayMouseUp(e) {
            if (this.overlayMouseDownOnOverlay && e.target.classList.contains('modal-overlay')) {
                this.closeModals();
            }
            this.overlayMouseDownOnOverlay = false;
        },
    },
}
</script>

<style scoped>
hr {
    border-top: 1px solid black;
}

button p,
p {
    color: #212529;
}

.next-previous {
    background-color: white;
    color: black;
}

.next-previous:disabled {
    background-color: white;
    cursor: not-allowed;
}

.description-clamp {
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Fix toast position */
::v-deep .toast-container {
    position: fixed !important;
    width: 300px;
    top: 20px !important;
    right: 20px !important;
    z-index: 99999 !important;
}

@media (min-width: 330px) {
    .cms-container {
        margin-top: 70px;
    }

    .cms-container.dimmed {
        position: relative;
    }

    .cms-container.dimmed::before {
        content: "";
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.1);
        z-index: 2;
    }

    .table-container {
        max-height: 350px;
        height: 350px;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    thead th {
        position: sticky;
        top: 0;
        background-color: var(--vmc-primary-6);
        color: white;
    }

    th {
        width: 16.66%;
    }

    tr:nth-child(odd) {
        background-color: #f0f0f0;
    }

    .search-bar {
        margin-top: 10px;
        width: 100%;
    }

    .filter {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row-reverse;
        margin-top: 10px;
    }

    .modal-overlay {
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 9999;
        overflow-y: auto;
        overscroll-behavior: contain;
    }

    .modal-content {
        border-radius: 8px;
        width: 400px;
        max-width: 90%;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
        animation: slideDown 0.3s ease-out;
    }

    .modal-header {
        background-color: #f5f5f5;
        border-bottom: 1px solid #ddd;
    }

    .modal-header h2 {
        font-size: 1.2rem;
    }

    .modal-body {
        padding: 20px;
    }

    @keyframes slideDown {
        from {
            transform: translateY(-20px);
            opacity: 0;
        }

        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
}

@media (min-width: 768px) {
    .search-bar {
        width: 300px;
    }

    .table-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}

@media (min-width: 992px) {}

@media (min-width: 1200px) {
    .cms-container {
        margin-left: 310px;
        width: calc(100% - 310px);
        margin-top: 105px;
    }

    .table-container::-webkit-scrollbar {
        width: 4px;
    }

    .table-container::-webkit-scrollbar-thumb {
        background-color: #666;
    }

    .table-container::-webkit-scrollbar-thumb:hover {
        background: #6b7280;
    }

    .search-container {
        margin-top: 0;
    }
}
</style>